import React from 'react'
import Popup from '../components/Popup'
import Button from '../components/Button'

const ClearListPopup: React.FC<{
  onClose: () => void
  onConfirm: () => void
  listName: string
}> = ({
  onClose,
  onConfirm,
  listName,
}) => {
  return (
    <Popup onClose={onClose}>
      <div className="title">
        Clear <strong>{listName}</strong>
      </div>
      <div className="subtitle">
        Do you want to start a new list?
        <br />Note: your current list will be permanently deleted.
      </div>

      <div className="buttonRow">
        <Button
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          buttonStyle="redStroke"
          onClick={() => onConfirm()}
        >
          Clear List
        </Button>
      </div>
    </Popup>
  )
}

export default ClearListPopup